export const myAccountLink = {
    "title" : "My account",
    "url" : "/"
};